import { HttpParams, HttpResponse } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
    FilterSearchingAlertaProductoRechazadoViewModel,
    AlertaProductoRechazadoViewModel,
    AlertaProductoRechazadoItemResultsViewModel,
} from './alertaProductoRechazado.types';

@Injectable()
export class AlertaProductoRechazadoService {
    alertaProductoRechazadoEndpoint = this.baseUrl + 'api/mantenimiento/alertaproductorechazado/';
    private lastSearch?: FilterSearchingAlertaProductoRechazadoViewModel;

    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {}

    private convertModelToHttpParms(payload: FilterSearchingAlertaProductoRechazadoViewModel): HttpParams {
        let params = new HttpParams();
        let k: keyof FilterSearchingAlertaProductoRechazadoViewModel;

        for (k in payload) {
            let timeStamp = payload[k]?.toLocaleString();
            let v;

            if (k == 'FechaEnvio') {
                v = timeStamp;
            } else {
                v = payload[k] || '';
            }

            params = params.append(k, v);
        }

        return params;
    }

    getAlertasProductosRechazados(payload: FilterSearchingAlertaProductoRechazadoViewModel): Observable<AlertaProductoRechazadoItemResultsViewModel> {
        this.lastSearch = payload; // Keep for future search
        const params = this.convertModelToHttpParms(payload);
        return this.getAlertaProductoRechazadoPagedByFilter(params);
    }

    getAlertaProductoRechazadoPagedByFilter(params: HttpParams): Observable<AlertaProductoRechazadoItemResultsViewModel> {
        return this.http.get<AlertaProductoRechazadoItemResultsViewModel>(this.alertaProductoRechazadoEndpoint + 'pagedbyfilter/', { params: params });
    }

    getAlertaProductoRechazado(id: number): Observable<AlertaProductoRechazadoViewModel> {
        return this.http.get<AlertaProductoRechazadoViewModel>(this.alertaProductoRechazadoEndpoint + id);
    }

    export(model: FilterSearchingAlertaProductoRechazadoViewModel): Observable<HttpResponse<Blob>> {
        return this.http.post(this.alertaProductoRechazadoEndpoint + 'postExportExcelByFilter', model, { observe: 'response', responseType: 'blob' });
    }

    getLastSearch(): FilterSearchingAlertaProductoRechazadoViewModel | undefined {
        return this.lastSearch;
    }

    clearLastSearch(): void {
        this.lastSearch = undefined;
    }
}
